// Analytics for the Subheader (ES-13522).
//
// Every consumer passes a small `analytics` context — { section, pageTitle,
// modelName, modelYear }. Section defaults to "Product" when omitted.

import dataLayer from "@analytics/dataLayer";

const pushClick = (ctx, label, category = "Sub Nav", extra = {}) => {
  dataLayer.push({
    event: "click",
    page: { section: ctx?.section || "Product", name: ctx?.pageTitle },
    product: { modelName: ctx?.modelName, modelYear: ctx?.modelYear },
    interaction: { category, label },
    ...extra,
  });
};

// Tab navigation (label = the tab title).
export function tabClick(ctx, navTitle) {
  pushClick(ctx, navTitle);
}

// Opening the collapsed active-tab dropdown — parity with subNavDropdownClick.
export function tabDropdownClick(ctx) {
  pushClick(ctx, "Dropdown");
}

// Favorite toggle — successor to the legacy bookmarkClick (Add/Remove).
export function favoriteClick(ctx, added) {
  pushClick(ctx, `${added ? "Add" : "Remove"} Favorite`);
}

// Share (opening the share popover).
export function shareClick(ctx) {
  pushClick(ctx, "Share");
}

// Which share destination was chosen inside the popover (Email / X / LinkedIn /
// Facebook / Copy Link).
export function shareOptionClick(ctx, option) {
  pushClick(ctx, option, "Share");
}

// Print — new action for pages with a print layout.
export function printClick(ctx) {
  pushClick(ctx, "Print");
}

// App back control (subheader chevron, article link, search row chevron).
export function backClick(ctx) {
  pushClick(ctx, "Back");
}

// Page feedback thumbs — new action; grouped under a "Feedback" category.
export function feedbackClick(ctx, vote) {
  pushClick(ctx, vote === "up" ? "Helpful" : "Not helpful", "Feedback");
}

// Thumbs-down comment popover: sending the written comment vs skipping it.
export function feedbackCommentSend(ctx) {
  pushClick(ctx, "Send Comment", "Feedback");
}
export function feedbackCommentSkip(ctx) {
  pushClick(ctx, "Skip Comment", "Feedback");
}

// Model/year dropdown click from VehicleYearDropdown.
export function modelYearDropdownClick(event) {
  dataLayer.push({
    event: "click",
    page: { section: "Product", name: event?.modelName },
    product: { modelName: event?.modelName, modelYear: event?.modelYear },
    interaction: { category: "Sub Nav", label: "Model Year Dropdown" },
    content: { title: event?.modelYear },
  });
}
